import { getRoute } from "@/functions/getRoute";
import { getGlobal } from "@/functions/getGlobal";
import { blog_helper } from "@/helpers/blog_helper";
import BackButton from "@/components/BackButton";
import Blog from "@/components/Blog";
import { consultant_helper } from "@/helpers/consultant_helper"; 
import SeoHead from "@/components/SeoHead";
import { Cookies } from "@/components";

export default function BlogPage({ filtered_blogs, blog }) {
  const global = getGlobal();

  const consultant = consultant_helper.fetch({filter: (i) => (i.name == blog.author)})[0]

  function extractWords(text, number) {
    if (!text || typeof window == "undefined") {
      return "";
    }

    const words = text.split(/\s+/);
    const extractedWords = words.slice(0, number).join(' ');

    const tempElement = document.createElement('div');
    tempElement.innerHTML = extractedWords;
    const plainText = tempElement.textContent || tempElement.innerText;

    return plainText;
  }

  return (
    <>
      <main style={{marginTop: '120px'}}>
        <SeoHead
            page_name={`${blog?.title} | Xcede Group`}
            description={extractWords(blog?.body, 155)}
            canonical_link={`https://www.xcedegroup.com/blog/${blog?.url_slug}`}
            robots="noindex, follow"
          />
        <div style={{padding: '1px 60px 0'}}>
          <BackButton />
        </div>
        <Blog blog={blog} consultant={consultant} filtered_blogs={filtered_blogs} />
      </main>
      
    </>
  );
}

export async function getStaticProps({ params: { url_slug } }) {
  const blog = blog_helper.find(url_slug);
  const all_blogs = blog_helper.fetch();

  const filtered_blogs = all_blogs
  .filter(item => item.url_slug !== url_slug)
  .filter(item => item.category === blog.category)
  .sort((a, b) => new Date(b.publish_date) - new Date(a.publish_date))
  .slice(0, 3);

  return {
    props: {
      filtered_blogs,
      blog
    },
  };
}

export async function getStaticPaths() {
  return { paths: blog_helper.toPaths(), fallback: false };
}
